import * as React from "react";
import { Permission } from "../authSchema";
import { defineMessage, FormattedMessage, MessageDescriptor } from "react-intl";
import { useAuth } from "../context/auth";
import { Link as RouterLink } from "react-router-dom";
import { Divider, Link as MUILink, Typography } from "@mui/material";

export const HasPermission = (props: { name: Permission; children: React.ReactNode }) => {
    const auth = useAuth();
    return auth.hasPermission(props.name) ? props.children : null;
};

export const HasNoPermission = (props: { name: Permission; children: React.ReactNode }) => {
    const auth = useAuth();
    return !auth.hasPermission(props.name) ? props.children : null;
};

export const valueOrEmpty = (val: any) => (val !== null && val !== "" ? val : <Empty lowercase />);

export const Empty = ({ label, lowercase }: { label?: MessageDescriptor; lowercase?: boolean }) => (
    <span
        style={{
            fontStyle: "italic",
            opacity: 0.7,
            textTransform: lowercase ? "lowercase" : "unset",
        }}
    >
        <FormattedMessage {...(label || defineMessage({ id: "empty", defaultMessage: "Empty" }))} />
    </span>
);

type LinkProps = {
    to: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
};

export const Link = ({ to, children, style }: LinkProps) => (
    <MUILink component={RouterLink} to={to} style={style}>
        {children}
    </MUILink>
);

export const SimpleSection = (props: { title: MessageDescriptor; children: React.ReactNode }) => {
    return (
        <div style={{ margin: 10 }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Divider style={{ width: 10 }} />
                <Typography variant="subtitle2" style={{ padding: "0 5px" }} color="textSecondary">
                    <FormattedMessage {...props.title} />
                </Typography>
                <Divider style={{ flexGrow: 1 }} />
            </div>
            <div style={{ margin: "5px 15px" }}>{props.children}</div>
        </div>
    );
};
